import { useState, useEffect } from 'react';
import logo from '../assets/logo.png';
import './Navbar.css';

const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/#services' },
  { label: 'About', href: '/#about' },
  { label: 'Reviews', href: '/#reviews' },
  { label: 'Contact', href: '/#contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('/');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setActive(window.location.pathname + window.location.hash);
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="container nav-inner">
        <a href="/" className="nav-logo">
          <img src={logo} alt="LathiNyx DevLabs" className="logo-img" />
        </a>

        <ul className={`nav-links ${open ? 'open' : ''}`}>
          {NAV_LINKS.map(l => (
            <li key={l.label}>
              <a
                href={l.href}
                className={active === l.href ? 'nav-active' : ''}
                onClick={() => { setActive(l.href); setOpen(false); }}
              >{l.label}</a>
            </li>
          ))}
        </ul>

        <a href="/#contact" className="btn-primary nav-cta">Get a Quote</a>
        <button className="hamburger" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}

